module.exports = __webpack_public_path__ + "img/remark.f1663d65.png";